import {gql} from "@apollo/client";

export const LOGIN_MUTATION = gql`
    mutation Login($username: String!, $password: String!) {
        login(username: $username, password: $password) {
            token
            user {
                id
                username
                email
                role
                rentalRole
                permissions
                isActive
                isVerified
                organization {
                    id
                    name
                }
            }
        }
}`;

export const FORGOT_PASSWORD_MUTATION = gql`
    mutation ForgotPassword($email: String!) {
        forgotPassword(email: $email) {
            message
        }
}`;

export const RESET_PASSWORD_MUTATION = gql`
    mutation ResetPassword($email: String!, $token: String!, $newPassword: String!) {
        resetPassword(email: $email, token: $token, newPassword: $newPassword) {
            message
        }
}`;

export const VERIFY_ACCOUNT_MUTATION = gql`
    mutation VerifyAccount($token: String!) {
        verifyAccount(token: $token) {
            message,
            success
        }
}`;